import React from 'react'
import moment, {Moment} from 'moment'
import FomatterType from '../types/fomatterType'

const numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']
const functionKeys = ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete', 'Backspace']

const calculateCurrentValue = (event: React.KeyboardEvent<HTMLInputElement>, firstNumberLimit: number, allNumberLimit: number) => {
    const target = event.currentTarget
    const key = event.key
    const currentValue = target.value
    const selectionStart = target.selectionStart || 0
    const selectionEnd = target.selectionEnd || 0

    if (currentValue === '00' && selectionEnd - selectionStart === 0) event.preventDefault()

    let stringValue = ''
    if (selectionStart === 0 && selectionEnd === 0) {
        stringValue = `${key}${currentValue}`
    } else if (selectionStart === 0 && selectionEnd === 1) {
        stringValue = `${key}${currentValue.substring(1, 2)}`
    } else if (selectionStart === 0 && selectionEnd === 2) {
        stringValue = `${key}`
    } else if (selectionStart === 1 && selectionEnd === 1) {
        stringValue = `${currentValue.substring(0, 1)}${key}${currentValue.substring(1, 2) ? currentValue.substring(1, 2) : ''}`
    } else if (selectionStart === 1 && selectionEnd === 2) {
        stringValue = `${currentValue.substring(0, 1)}${key}`
    } else if (selectionStart === 2 && selectionEnd === 2) {
        stringValue = `${currentValue}${key}`
    }

    if (stringValue.length === 2) {
        if (Number(stringValue) > allNumberLimit) event.preventDefault()
    } else {
        if (Number(stringValue) > firstNumberLimit) event.preventDefault()
    }
}

const phoneFomatter = (num: string, type: null | boolean) => {
    let formatNum = ''
    if (num.length === 11) {
        if (type) {
            formatNum = num.replace(/(\d{3})(\d{4})(\d{4})/, '$1-****-$3')
        } else {
            formatNum = num.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3')
        }
    } else if (num.length === 8) {
        formatNum = num.replace(/(\d{4})(\d{4})/, '$1-$2')
    } else {
        if (num.indexOf('02') === 0) {
            if (type) {
                formatNum = num.replace(/(\d{2})(\d{4})(\d{4})/, '$1-****-$3')
            } else {
                formatNum = num.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3')
            }
        } else {
            if (type) {
                formatNum = num.replace(/(\d{3})(\d{3})(\d{4})/, '$1-***-$3')
            } else {
                formatNum = num.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
            }
        }
    }

    return formatNum
}
export const keyPressNumberOnly = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (!numbers.includes(event.key)) {
        event.preventDefault()
    }
}

export const keyPressFunctions = (event: React.KeyboardEvent<HTMLInputElement>): boolean => {
    return functionKeys.includes(event.key)
}

export const targetValueArrowDown = (event: React.KeyboardEvent<HTMLInputElement>, type: 'TIME' | 'MIN') => {
    if (event.currentTarget.value) {
        let setNum = Number(event.currentTarget.value) - 1

        if (type === 'TIME') {
            setNum = setNum < 0 ? 23 : setNum
        } else {
            setNum = setNum < 0 ? 59 : setNum
        }

        event.currentTarget.value = `${setNum >= 10 ? setNum : `0${setNum}`}`
    } else {
        event.currentTarget.value = type === 'TIME' ? '23' : '59'
    }
}

export const targetValueArrowUp = (event: React.KeyboardEvent<HTMLInputElement>, type: 'TIME' | 'MIN') => {
    if (event.currentTarget.value) {
        let setNum = Number(event.currentTarget.value) + 1

        if (type === 'TIME') {
            setNum = setNum > 23 ? 0 : setNum
        } else {
            setNum = setNum > 59 ? 0 : setNum
        }

        event.currentTarget.value = `${setNum >= 10 ? setNum : `0${setNum}`}`
    } else {
        event.currentTarget.value = '01'
    }
}

export const keyPressFunctionAction = (event: React.KeyboardEvent<HTMLInputElement>, type: 'TIME' | 'MIN') => {
    switch (event.key) {
        case 'ArrowUp':
            targetValueArrowUp(event, type)
            calculateCurrentValue(event, 5, 59)
            event.preventDefault()
            break
        case 'ArrowDown':
            targetValueArrowDown(event, type)
            calculateCurrentValue(event, 2, 23)
            event.preventDefault()
            break
    }
}

export const keyPressNumberTime = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (keyPressFunctions(event)) {
        keyPressFunctionAction(event, 'TIME')
    } else {
        keyPressNumberOnly(event)
        calculateCurrentValue(event, 2, 23)
    }
}

export const keyPressNumberMinute = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (keyPressFunctions(event)) {
        keyPressFunctionAction(event, 'MIN')
    } else {
        keyPressNumberOnly(event)
        calculateCurrentValue(event, 5, 59)
    }
}

export const keyPressNumberPhone = (event: React.KeyboardEvent<HTMLInputElement>) => {
    keyPressNumberOnly(event)

    const currentValue = event.currentTarget.value
    if (currentValue) {
        if (currentValue.length + 1 >= 12) event.preventDefault()
    }
}

export const markDayHyphen = (val: string | undefined, defaultStr?: string, formatString?: string) => {
    let format = 'YY-MM-DD'
    if (formatString) {
        format = formatString
    }
    if (val) {
        return moment(val).format(format)
    }
    return defaultStr ? defaultStr : '-'
}

export const markHyphen = (val: number | string | undefined, defaultStr?: string) => {
    if (val) {
        return val
    }
    return defaultStr ? defaultStr : '-'
}

export const includeComma = (number: number | string | undefined, defaultStr?: string) => {
    if (!number) {
        return defaultStr ? defaultStr : ''
    }
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

/** 0 원 표시 가능한 금액 콤마 찍는 함수*/
export const includeCommaWithZero = (number: number | string | undefined, defaultStr?: string) => {
    if (number === undefined || number === null || number === '') {
        return defaultStr ? defaultStr : '';
    }
    if (number === 0 || number === '0') {
        return '0';
    }
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}


export const onKeyDownCheckEnter = (e: React.KeyboardEvent, action: Function) => {
    if (e.key === 'Enter') {
        action()
    }
}
/*
 * TEL: 전화 번호
 * DATE: 년월일
 * BIZ: 사업자 등록 번호
 */
export const commonFomatter = (type: FomatterType, value: string | number | null | undefined) => {
    if (value)
        switch (type) {
            case FomatterType.TEL:
                return phoneFomatter(value.toString(), false)
            case FomatterType.DATE:
                return moment(value).format('YYYY-MM-DD')
            case FomatterType.BIZ:
                return value.toString().replace(/(\d{3})(\d{2})(\d{5})/, '$1-$2-$3')
            case FomatterType.TIME:
                if (typeof value === 'string' && value.length === 4) {
                    const hours = value.substring(0, 2)
                    const minutes = value.substring(2)
                    return `${hours}:${minutes}`
                }
                if (typeof value === 'string' && value.length === 8) {
                    const hours = value.substring(0, 2)
                    const minutes = value.substring(3, 5)
                    return `${hours}:${minutes}`
                }
                // 유효하지 않은 형식의 입력이라면 오류 처리
                return '-'

        }
}

export const weekOfMonth = (date: Moment) => {
    return date.week() - moment(date).startOf('month').week() + 1
}

export const inputNumberAutoCompleteRef = (e: HTMLInputElement | null) => {
    if (e) e.autocomplete = 'one-time-code'
    return e
}

export const koreanRegExp = (value: string | undefined) => {
    if (!value) {
        return false
    }

    return /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(value)
}
export const onBlurReplaceTime = (event: React.FocusEvent<HTMLInputElement>, isRequired?: boolean) => {
    const korean = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/

    if (korean.test(event.currentTarget.value)) {
        event.target.focus()
    }

    if (isRequired && event.currentTarget.value.length < 2) {
        event.currentTarget.value = `0${event.currentTarget.value ? event.currentTarget.value : '0'}`
    }
}
